import { Field } from '@ardoq/forms';
import { ComponentType } from 'react';
import { ContainerProps, components } from 'react-select';
import { CommonSelectProps, SelectOption } from '../../types';

export const SelectContainer: ComponentType<
  ContainerProps<SelectOption<unknown>>
> = ({ children, ...props }) => {
  const { selectProps, isDisabled } = props;
  const {
    label,
    hintMessage,
    helperText,
    errorMessage,
    warningMessage,
    formSize,
    onCloseFieldClick,
    closeFieldIconTooltip,
    dataTestId,
    dataTourId,
    indicator,
    i18nLocale,
    reactSortableRef,
    reactSortableMouseDownHandler,
    popoverContent,
    popoverHelpContent,
  } = selectProps as CommonSelectProps;

  return (
    <Field
      label={label}
      inputId={selectProps.inputId}
      isDisabled={isDisabled}
      indicator={indicator}
      i18nLocale={i18nLocale}
      helperText={helperText}
      formSize={formSize}
      onCloseFieldClick={onCloseFieldClick}
      closeFieldIconTooltip={closeFieldIconTooltip}
      hintMessage={hintMessage}
      errorMessage={errorMessage}
      warningMessage={warningMessage}
      popoverContent={popoverContent}
      popoverHelpContent={popoverHelpContent}
    >
      <components.SelectContainer
        {...props}
        // Using className AND data-test-id here for backwards compatibiity, some tests may already rely on the class as a selector
        className={['select-container', props.className].join(' ')}
        innerProps={Object.assign({}, props.innerProps, {
          'data-test-id': dataTestId,
          'data-tour-id': dataTourId,
          ref: reactSortableRef,
          onMouseDownCapture: reactSortableMouseDownHandler,
        })}
      >
        {children}
      </components.SelectContainer>
    </Field>
  );
};
